import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { useSentry } from '../composables/sentry'
import { FlowState } from '../constants/flowState'
import BaseModelService from '../services/BaseModelService'

const { handleError } = useSentry()

export const useBaseModelStore = defineStore('BaseModelStore', () => {
  const flow = ref<FlowState>(FlowState.Idle)
  const model = ref<any>()
  const productInquiryUrl = computed(() => {
    if (!model.value?.vendor || !model.value?.model)
      return null
    const productName = `${model.value?.vendor} ${model.value?.model}`

    return `https://info.mceautomation.com/daughtridge-order?daughtridge_product_name=${productName}&utm_source=${model.value?.model_uri}`
  })

  async function getBaseModel(uri: string) {
    try {
      flow.value = FlowState.Loading
      const res = await BaseModelService.getBaseModel(uri)
      if (!res.success) {
        flow.value = FlowState.Error
        throw new Error('Issue retrieving the Configurator Model')
      }
      if (res.success && res.exists) {
        model.value = { ...res?.data }
        flow.value = FlowState.Idle
      }
      else if (res.success && !res.exists) {
        flow.value = FlowState.NotFound
      }
      else {
        flow.value = FlowState.Error
      }
      return {
        success: true
      }
    }
    catch (error: any) {
      handleError(error)
      return {
        success: false
      }
    }
  }

  return {
    flow,
    model,
    getBaseModel,
    productInquiryUrl
  }
})
